// Loop stored link items and see if any of them are no longer applicable.
// Inapplicable ones are added into invalidLinkedItemArr
export function getInapplicableLinkItems(
    newLinkItems, transactionLinkItems, invalidLinkedItemArr) {
    transactionLinkItems.forEach(txnLinkItem => {
        const hasItem = newLinkItems.find(
            i => i.target_transaction_id === txnLinkItem.target_transaction_id,
        );
        if (!hasItem)
            invalidLinkedItemArr.push(txnLinkItem.number);
    });
}
